// MENU SETUP
export function activateMenu() {
  isActive() ? openMenu() : closeMenu();
}

const isActive = function () {
  if (navItems.classList.contains('open')) {
    return true;
  } else {
    return false;
  }
};

document.getElementById('navBtn').addEventListener('click', activateMenu);

function openMenu() {
  const navItems = document.getElementById('navItems');
  const navBtn = document.getElementById('navBtn');
  navItems.classList.toggle('open');
  navBtn.classList.toggle('open');

  const scrollY = document.body.style.top;
  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

function closeMenu() {
  const navItems = document.getElementById('navItems');
  const navBtn = document.getElementById('navBtn');
  navItems.classList.toggle('open');
  navBtn.classList.toggle('open');

  document.body.style.position = 'fixed';
  document.body.style.top = `${window.scrollY}px`;
  document.body.style.width = '100%';
}
